@let detail = detailInput();
<div class="content">
  @if (errorMessage()) {
    <div class="errorMessage">
      {{ errorMessage() }}
    </div>
  }
  @if (warningMessage) {
    <div class="warningMessage">
      {{ warningMessage }}
    </div>
  }
  <div class="containerRow">
    <div class="inputContainer">
      <div class="containerRow">
        <div class="inputContainer">
          <div class="inputRow">
            @if (isCooling()) {
              <label class="inputLabel">Chiller Fluid Temp:</label>
            }
            @if (!isCooling()) {
              <label class="inputLabel">Boiler Fluid Temp:</label>
            }
            @if (isCooling()) {
              <input class="inputField activeInput" [(ngModel)]="detail.coolingEnteringFluidTemperature"
                (change)="recalculateLoop()"/>
            }
            @if (!isCooling()) {
              <input class="inputField activeInput"
                [(ngModel)]="detail.heatingEnteringFluidTemperature" (change)="recalculateLoop()"/>
            }
          </div>
          <div class="inputRow">
            <label class="inputLabel">Fluid Temp Change:</label>
            <input type="number" class="inputField" [(ngModel)]="temperatureChangeInput"
              (change)="temperatureInputChanged()" [class.activeInput]="!flowRateLocked"/>
          </div>
        </div>
        <div class="inputContainer">
          <fieldset class="inputFieldset">
            <legend>Peak Load</legend>
            <div class="inputRow">
              <label class="fieldInputLabel">Total:</label>
              @if (isCooling()) {
                <input class="inputField" [readonly]="true"
                  [(ngModel)]="detail.coolingPeakTotalCapacity"/>
              }
              @if (!isCooling()) {
                <input class="inputField" [readonly]="true"
                  [(ngModel)]="detail.heatingPeakTotalCapacity"/>
              }
              @if (isCooling()) {
                <label class="fieldInputLabel">Sensible:</label>
              }
              @if (isCooling()) {
                <input class="inputField" [readonly]="true"
                  [(ngModel)]="detail.coolingPeakSensibleCapacity"/>
              }
            </div>
          </fieldset>
        </div>
        <div class="inputContainer">
          <div class="inputRow">
            <label class="narrowInputLabel">Flow Rate:</label>
            <input type="number" class="inputField" [(ngModel)]="flowRateInput" (change)="flowRateInputChanged()"
              [class.activeInput]="flowRateLocked"/>
          </div>
          <div class="inputRow">
            <label class="narrowInputLabel">Pipe Size:</label>
            @if (isCooling()) {
              <select [(ngModel)]="detail.coolingPipeId" class="selectionInput"
                [class.invalid]="isInvalidFlowRate" (change)="recalculateLoop()">
                @for (pipe of availablePipes(); track pipe) {
                  <option
                    [value]="pipe.Id">{{ detail.metric ? pipe.MetricDisplayValue : pipe.ImperialDisplayValue }}
                  </option>
                }
              </select>
            }
            @if (!isCooling()) {
              <select [(ngModel)]="detail.heatingPipeId" class="selectionInput"
                [class.invalid]="isInvalidFlowRate" (change)="recalculateLoop()">
                @for (pipe of availablePipes(); track pipe) {
                  <option
                    [value]="pipe.Id">{{ detail.metric ? pipe.MetricDisplayValue : pipe.ImperialDisplayValue }}
                  </option>
                }
              </select>
            }
          </div>
        </div>
      </div>
      <div class="containerRow">
        <div class="inputContainer">
          @if (isCooling()) {
            <div class="inputRow">
              <label class="inputLabel">Target SHR%:</label>
              <input matTooltipClass="invalidReasonTooltip"
                matTooltip="This is the target Sensible Heat Ratio percentage. It is used to calculate the Room Sensible Load = ((SHR% / 100) * Room Total Load)"
                class="inputField activeInput"
                [(ngModel)]="detail.coolingTargetSensibleHeatRatio" (change)="recalculateLoop()"/>
            </div>
          }
          <div class="inputRow">
            <label class="inputLabel">Leaving Fluid Temp:</label>
            @if (isCooling()) {
              <input class="inputField" [readonly]="true"
                [(ngModel)]="detail.coolingLeavingFluidTemperature"/>
            }
            @if (!isCooling()) {
              <input class="inputField" [readonly]="true"
                [(ngModel)]="detail.heatingLeavingFluidTemperature"/>
            }
          </div>
        </div>
        <div class="inputContainer">
          <fieldset class="inputFieldset">
            <legend>Actual Capacity</legend>
            <div class="inputRow">
              <label class="fieldInputLabel">Total:</label>
              @if (isCooling()) {
                <input class="inputField" [readonly]="true"
                  [(ngModel)]="detail.coolingActualTotalCapacity"/>
              }
              @if (!isCooling()) {
                <input class="inputField" [readonly]="true"
                  [(ngModel)]="detail.heatingActualTotalCapacity"/>
              }
              @if (isCooling()) {
                <label class="fieldInputLabel">Sensible:</label>
              }
              @if (isCooling()) {
                <input class="inputField" [readonly]="true"
                  [(ngModel)]="detail.coolingActualSensibleCapacity"/>
              }
            </div>
          </fieldset>
        </div>
        <div class="inputContainer">
          <div class="inputRow">
            <label class="narrowInputLabel">Fluid Velocity:</label>
            @if (isCooling()) {
              <input class="inputField" [readonly]="true" [(ngModel)]="detail.coolingFluidVelocity"
                [class.invalid]="isInvalidFlowRate"/>
            }
            @if (!isCooling()) {
              <input class="inputField" [readonly]="true" [(ngModel)]="detail.heatingFluidVelocity"
                [class.invalid]="isInvalidFlowRate"/>
            }
          </div>
          <div class="inputRow">
            <label class="narrowInputLabel">Fluid:</label>
            <input class="inputField" [readonly]="true" [value]="$safeNavigationMigration(loopFluidType()?.description)"/>
            @if (isCooling() && isGlycol()) {
              <span>
                <label class="narrowInputLabel">Glycol %:</label>
                <input class="narrowInputField" [readonly]="true" type="number"
                  [(ngModel)]="detail.coolingGlycolPercentage"/>
              </span>
            }
            @if (!isCooling() && isGlycol()) {
              <span>
                <label class="narrowInputLabel">Glycol %:</label>
                <input class="narrowInputField" [readonly]="true" type="number"
                  [(ngModel)]="detail.heatingGlycolPercentage"/>
              </span>
            }
          </div>
        </div>
      </div>
    </div>
    <div class="inputContainer">
      @if (selectedModelCode) {
        <div class="imageContainer">
          <img class="unitImage" [src]="getModelImageFileName()" alt=""/>
        </div>
      }
    </div>
  </div>
  <div class="toolbar">
    <button matButton="text" class="toolbarButton" (click)="autoSelectUnits()">
      <span>
        <mat-icon class="size-16">auto_awesome</mat-icon>
        <label>Auto-Select</label>
      </span>
    </button>
    <button matButton="text" class="toolbarButton" (click)="addLoopUnit()">
      <span>
        <mat-icon class="size-16">add</mat-icon>
        <label>Add Unit</label>
      </span>
    </button>
    <button matButton="text" class="toolbarButton" (click)="addNonSFUnit()">
      <span>
        <mat-icon class="size-16">add_circle_outline</mat-icon>
        <label>Add Non-SF Unit</label>
      </span>
    </button>
    <button matButton="text" class="toolbarButton" [disabled]="!canRearrange()" (click)="rearrangeUnits()">
      <span>
        <mat-icon class="size-16">low_priority</mat-icon>
        <label>Rearrange</label>
      </span>
    </button>
    <span class="spacer"></span>
    <button matButton="text" class="toolbarButton" [disabled]="!canEdit()" (click)="editSelectedUnit()">
      <span>
        <mat-icon class="size-16">edit</mat-icon>
        <label>Edit</label>
      </span>
    </button>
    <button matButton="text" class="toolbarButton" [disabled]="!canCopy()" (click)="copySelectedUnit()">
      <span>
        <mat-icon class="size-16">content_copy</mat-icon>
        <label>Copy</label>
      </span>
    </button>
    <button matButton="text" class="toolbarButton" [disabled]="!canDelete()" (click)="deleteSelectedUnits()">
      <span>
        <mat-icon class="size-16">delete</mat-icon>
        <label>Delete</label>
      </span>
    </button>
    <span class="spacer"></span>
    <button matButton="text" class="toolbarButton" [disabled]="isBusy()" (click)="recalculateLoop()">
      <span>
        <mat-icon class="size-16">calculate</mat-icon>
        <label>Recalculate</label>
      </span>
    </button>
  </div>
  <div class="tableWrapper">
    <app-sure-flow-units-grid (unitSelectionChanged)="unitSelected($event)" [selectedUnitIds]="selectedUnitIds()"
      [invalidUnitIds]="invalidUnitIds()" [units]="units()" [isCooling]="isCooling()"
    [isMetric]="detail.metric"></app-sure-flow-units-grid>
  </div>
  @if (isCooling() && coolingChartData) {
    <div class="chartWrapper">
      <app-line-chart [data]="coolingChartData"></app-line-chart>
    </div>
  }
  @if (!isCooling() && heatingChartData) {
    <div class="chartWrapper">
      <app-line-chart [data]="heatingChartData"></app-line-chart>
    </div>
  }
</div>
@if (isBusy()) {
  <div class="busyIndicator">
    <div class="busyContents">
      <mat-progress-spinner diameter="48" mode="indeterminate"></mat-progress-spinner>
      <label class="busyLabel">Please Wait...</label>
    </div>
  </div>
}
